<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-numerictextbox
            [ngClass]="generateInputStyle()"
            [id]="id"
            [title]="title | translate"
            [format]="format"
            [min]="min"
            [max]="max"
            [autoCorrect]="true"
            [disabled]="isDisabled"
            [placeholder]="placeholder"
            [decimals]="decimals"
            [readonly]="isDisabled"
            [spinners]="showSpinners"
            [(ngModel)]="value"
            (valueChange)="onValueChange($event)"
            (inputFocus)="onFocusIn()"
            (inputBlur)="onFocusOut()"
            (input)="onInput($event)" />
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span class="pt-1.5 pb-1" kendoTooltip [title]="displayValue()">
                {{ displayValue() }}
            </span>
        </div>
    }
</app-input-label>
